// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"71890f40","686":"19b30f5a","858":"cb9a7e26"}[chunkId] + ".chunk.js";
};